import type { Permission, UserRole } from "./types.ts";
import { dashboardPermission } from "./permissions/dashboard.ts";
import { probationPermission } from "./permissions/probation.ts";
import { timesheetPermission } from "./permissions/timesheet.ts";

export const PERMISSIONS: Record<Permission, UserRole[]> = {
  ...timesheetPermission,
  ...dashboardPermission,
  ...probationPermission,
};
